﻿
export const FilePickerState = {
    start: "start",
    drag: "drag",
    drop: "drop",
    uploading: "uploading",
    uploaded: "uploaded",
    failed: "failed"
};
